export default __webpack_public_path__ + "static/media/06.608ef5a3.jpg";